import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=44a92348&scoped=true&"
import script from "./ProfileAddress.vue?vue&type=script&lang=js&"
export * from "./ProfileAddress.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAddress.vue?vue&type=style&index=0&id=44a92348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a92348",
  null
  
)

export default component.exports